<template>
  <div class="passwortAendern">
    <v-row>
      <v-col cols="2">&nbsp;</v-col>
      <h2>Passwort ändern</h2>
      <v-col cols="2">&nbsp;</v-col>
    </v-row>
    <v-form ref="passwortAendernForm">
      <v-row>
        <v-col cols="2">&nbsp;</v-col>
        <v-col cols="8">
          <b-text-field
              label="Passwort"
              type="password"
              v-model="password"
              placeholder=" "
              :rules="[rules.required]"
          />
        </v-col>
        <v-col cols="2">&nbsp;</v-col>
      </v-row>
      <v-row>
        <v-col cols="2">&nbsp;</v-col>
        <v-col cols="8">
          <b-text-field
              label="Passwort wiederholen"
              type="password"
              v-model="passwordConfirm"
              placeholder=" "
              :rules="[rules.required, validations.wiederholungValidation('Passwörter', password, passwordConfirm)]"
          />
        </v-col>
        <v-col cols="2">&nbsp;</v-col>
      </v-row>
      <v-row>
        <v-col>
          <b-btn @click="passwordAendern()">Passwort Ändern</b-btn>
        </v-col>
      </v-row>
    </v-form>
    <v-snackbar v-model="showSnackbar" timeout="4000" color="red">
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>

<script>

import {mapGetters} from "vuex";
import validations from '@/service/validations';
import axios from "axios";

export default {
  name: 'PasswortAendern',
  data() {
    return {
      hint: 'Pflichtfeld',
      rules: {
        required: (value) => !!value || this.hint,
      },
      showSnackbar: false,
      snackbarText: '',
      validations: validations,
      password: null,
      passwordConfirm: null,
    };
  },
  mixins: [],
  computed: {
    ...mapGetters('userData', ['getUserData']),
  },
  methods: {
    passwordAendern() {
      if (this.$refs.passwortAendernForm.validate()) {
        const userData = {
          username: this.getUserData.userName,
          password: this.password
        };
        axios
          .put('/v1/auth/updatepassword', userData)
          .then((response) => {
            if (200 <= response.statusCode < 300) {
              this.$router.push('/projekt');
            }
          })
          .catch((error) => {
            if (error.response.message && error.response.message !== '') {
              this.snackbarText = error.response.message;
            } else {
              this.snackbarText = 'Ändern des Passworts fehlgeschlagen. Bitte überprüfen Sie ihre Eingabe-Daten';
            }
            this.showSnackbar = true;
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>

.passwortAendern {
  border: 1px solid #8A8A8A;
  padding: 80px;
  text-align: center;
  width: 66%;
  margin: 80px auto;
  h2 {
    text-align: left;
    padding-left: 12px;
  }
}

</style>